//todo: if working move to ea-imputs?
(function () {
    'use strict';
    window.cancelAnimationFrame = window.cancelAnimationFrame ||
        window.webkitCancelAnimationFrame ||
        window.mozCancelAnimationFrame;

    window.requestAnimationFrame = window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame;


    function ensureScript(url) {
        var exists = isScriptLoaded(url);
        if (!exists)
            addScript(url);
    }

    function isScriptLoaded(url) {
        if (!url) return;

        var scripts = document.getElementsByTagName('script');
        for (var i = scripts.length; i--;) {
            if (scripts[i].src == url)
                return true;
        }
        return false;
    }

    function addScript(url) {
        var head = document.getElementsByTagName("head")[0];
        var s = document.createElement("script");
        s.type = "text/javascript";
        s.src = url;
        head.appendChild(s);
    }

    var createReadOnlyVersion = function (object) {
        var obj = {};
        for (var property in object) {
            if (object.hasOwnProperty(property)) {
                Object.defineProperty(obj, property, {
                    get: (function (a) {
                        var p = a;
                        return function () {
                            return object[p];
                        }
                    })(property),
                    enumerable: true,
                    configurable: true
                });
            }
        }
        return obj;
    };

    var blobToDataURL = function (blob, callback) {
        var a = new FileReader();
        a.onload = function (e) {
            callback(e.target.result);
        };
        a.readAsDataURL(blob);
    };

    function recorderCtrl($scope, $timeout, $interval, element, service, recorderAPI, recorderUtils) {
        var PLAYBACK = {
            STOPPED: 0,
            PLAYING: 1,
            PAUSED: 2
        }

        var scopeApply = function (fn) {
            var phase = $scope.$root.$$phase;
            if (phase !== '$apply' && phase !== '$digest') {
                return $scope.$apply(fn);
            }
        };

        var control = this,
            timing = null,
            serviceData = null,
            audioObjId = 'recorded-audio-' + control.id,
            status = {
                isRecording: false,
                playback: PLAYBACK.STOPPED,
                isDenied: null,
                isConverting: false,
                get isPlaying() {
                    return status.playback === PLAYBACK.PLAYING;
                },
                get isStopped() {
                    return status.playback === PLAYBACK.STOPPED;
                },
                get isPaused() {
                    return status.playback === PLAYBACK.PAUSED;
                }
            };

        control.timeLimit = control.timeLimit || 0;
        control.status = createReadOnlyVersion(status);
        control.isAvailable = service.isAvailable();
        control.elapsedTime = 0;
        control.fisecret;
        //Sets ID for the element if ID doesn't exists
        if (!control.id) {
            control.id = recorderUtils.generateUuid();
            element.attr("id", control.id);
        }

        //register controller with service
        service.setController(control.id, this);

        var playbackOnEnded = function () {
            status.playback = PLAYBACK.STOPPED;
            control.onPlaybackComplete();
            scopeApply();
        };

        var playbackOnPause = function () {
            status.playback = PLAYBACK.PAUSED;
            control.onPlaybackPause();
        };

        var playbackOnStart = function () {
            status.playback = PLAYBACK.PLAYING;
            control.onPlaybackStart();
        };

        var playbackOnResume = function () {
            status.playback = PLAYBACK.PLAYING;
            control.onPlaybackResume();
        };

        var embedPlayer = function (blob) {
            if (document.getElementById(audioObjId) == null) {
                element.append('<audio type="audio/mpeg" id="' + audioObjId + '"></audio>');

                var audioPlayer = document.getElementById(audioObjId);
                if (control.showPlayer) {
                    audioPlayer.setAttribute('controls', '');
                }

                audioPlayer.addEventListener("ended", playbackOnEnded);
                audioPlayer.addEventListener("pause", function (e) {
                    if (this.duration !== this.currentTime) {
                        playbackOnPause();
                        scopeApply();
                    }
                });
                audioPlayer.addEventListener("playing", function (e) {
                    if (status.isPaused) {
                        playbackOnResume();
                    } else {
                        playbackOnStart();
                    }
                    scopeApply();
                });

            }

            if (blob) {
                blobToDataURL(blob, function (url) {
                    document.getElementById(audioObjId).src = url;
                });
            }
            else {
                document.getElementById(audioObjId).removeAttribute('src');
            }
        };

        control.getAudioPlayer = function () {
            return document.getElementById(audioObjId);
        };

        control.startRecord = function () {
            if (!service.isAvailable()) {
                return;
            }

            if (status.isPlaying) {
                control.playbackPause();
                //indicate that this is not paused.
                status.playback = PLAYBACK.STOPPED;
            }

            //clear audio previously recorded
            control.audioModel = null;

            let id = control.id;
            let recordHandler = service.getHandler();
            //Record initiation based on browser type
            var start = function () {
                if (service.isHtml5) {
                    //HTML5 recording
                    if (!recordHandler) {
                        return;
                    }


                    recordHandler.start();
                }

                status.isRecording = true;
                control.onRecordStart();
                control.elapsedTime = 0;
                timing = $interval(function () {
                    ++control.elapsedTime;
                    if (control.timeLimit && control.timeLimit > 0 && control.elapsedTime >= control.timeLimit) {
                        control.stopRecord();
                    }
                }, 1000);
            };

            if (recordHandler) {
                //service.clear();
                //service.showPermission();
                start();

            } else if (!status.isDenied) {
                //probably permission was never asked

                service.showPermission({
                    onDenied: function () {
                        status.isDenied = true;
                        $scope.$apply();
                    },
                    onAllowed: function () {
                        status.isDenied = false;
                        recordHandler = service.getHandler();
                        start();
                        scopeApply();
                    }
                });
            }
        };

        control.cancelRecording = function () {

        }

        control.stopRecord = function () {
            var id = control.id;
            if (!service.isAvailable() || !status.isRecording) {
                return false;
            }

            $interval.cancel(timing);
            //control.audioModel = null;
            status.isRecording = false;
            var recordHandler = service.getHandler();

            //To stop recording
            if (service.isHtml5) {
                if (recordHandler.state == "recording")
                    recordHandler.stop();
            } else {
                recordHandler.stopRecording(id);
                completed(recordHandler.getBlob(id));
            }
        };

        control.playbackRecording = function () {
            if (status.isPlaying || !service.isAvailable() || status.isRecording) {
                return false;
            }
            else
                control.getAudioPlayer().play();
        };

        control.playbackPause = function () {
            if (!status.isPlaying || !service.isAvailable() || status.isRecording) {
                return false;
            }

            control.getAudioPlayer().pause();
        };

        control.playbackResume = function () {
            if (status.isPlaying || !service.isAvailable() || status.isRecording || !control.audioModel) {
                return false;
            }

            if (status.isPaused) {
                //previously paused, just resume
                control.getAudioPlayer().play();
            } else {
                control.paudioRecorderlaybackRecording();
            }

        };

        function saveAudio(blob) {
            if (!service.isAvailable() || status.isRecording) {
                return false;
            }

            blobToDataURL(blob, function () {
                getFileService(event.target.result);
            })

        };

        control.isHtml5 = function () {
            return service.isHtml5;
        };

        if (control.autoStart) {
            $timeout(function () {
                control.startRecord();
            }, 1000);
        }

        element.on('$destroy', function () {
            $interval.cancel(timing);
        });

        window.addEventListener("imageUploaded", function (ev) {
            var postData = ev.detail;

            if (postData.clientID == control.id) {
                control.audioModel = postData.fieldID || control.fisecret;
                control.onRecordComplete();
                scopeApply();
            }
        });

        window.addEventListener('message', function (ev) {
            if (ev.data.msg == 'dataReady') {
                let blob = service.getBlob();
                completed(blob);
                scopeApply();
            }
        }, false)

        function completed(blob) {
            status.isRecording = false;
            let finalize = function (inputBlob) {
                embedPlayer(inputBlob);
            };

            finalize(blob)
            embedPlayer(null);
            //todo: if needed
            saveAudio(blob);

        }

        function getFileService(dataURL) {
            if (serviceData)
                uploadFile(serviceData, dataURL)
            else
                recorderAPI.GetDataURL(control.pid, control.key).then(function (response) {
                    if (!response || !response.data)
                        alert('An error has occurred');
                    else {
                        serviceData = response.data;
                        control.fisecret = response.data.fisecret;
                        uploadFile(response.data, dataURL)
                    }
                })
        }

        function uploadFile(serviceData, dataURL) {
            fileuploadsubmit(serviceData);
            SendFilesToService(dataURL, control.id);
        }
    };

    recorderCtrl.$inject = ['$scope', '$timeout', '$interval', '$element', 'recorderService', 'recorderAPI', 'recorderUtils'];

    angular.module('EventListApp')
        .controller('RecorderCtrl', recorderCtrl)

    angular.module('EventListApp')
        .directive('ngAudioRecorderAnalyzer', ['recorderService', 'recorderUtils',
            function (service, utils) {
                var link = function (scope, element, attrs, recorder) {
                    if (!service.isHtml5) {
                        scope.hide = true;
                        return;
                    }

                    var canvasWidth, canvasHeight, rafID, analyserContext, props = service.$html5AudioProps;

                    function updateAnalysers(time) {

                        if (!analyserContext) {
                            var canvas = element.find("canvas")[0];

                            if (attrs.width && !isNaN(attrs.width)) {
                                canvas.width = attrs.width;
                            }

                            if (attrs.height && !isNaN(attrs.height)) {
                                canvas.height = parseInt(attrs.height);
                            }

                            canvasWidth = canvas.width;
                            canvasHeight = canvas.height;
                            analyserContext = canvas.getContext('2d');
                        }

                        // analyzer draw code here
                        {
                            var SPACING = 3;
                            var BAR_WIDTH = 1;
                            var numBars = Math.round(canvasWidth / SPACING);
                            var freqByteData = new Uint8Array(props.analyserNode.frequencyBinCount);

                            props.analyserNode.getByteFrequencyData(freqByteData);

                            analyserContext.clearRect(0, 0, canvasWidth, canvasHeight);
                            //analyserContext.fillStyle = '#F6D565';
                            analyserContext.lineCap = 'round';
                            var multiplier = props.analyserNode.frequencyBinCount / numBars;

                            // Draw rectangle for each frequency bin.
                            for (var i = 0; i < numBars; ++i) {
                                var magnitude = 0;
                                var offset = Math.floor(i * multiplier);
                                // gotta sum/average the block, or we miss narrow-bandwidth spikes
                                for (var j = 0; j < multiplier; j++)
                                    magnitude += freqByteData[offset + j];
                                magnitude = magnitude / multiplier;
                                var magnitude2 = freqByteData[i * multiplier];
                                if (attrs.waveColor)
                                    analyserContext.fillStyle = attrs.waveColor;
                                else
                                    analyserContext.fillStyle = "hsl( " + Math.round((i * 360) / numBars) + ", 100%, 50%)";
                                analyserContext.fillRect(i * SPACING, canvasHeight, BAR_WIDTH, -magnitude);
                            }
                        }

                        rafID = window.requestAnimationFrame(updateAnalysers);
                    }

                    function cancelAnalyserUpdates() {
                        window.cancelAnimationFrame(rafID);
                        rafID = null;
                    }

                    element.on('$destroy', function () {
                        cancelAnalyserUpdates();
                    });

                    recorder.onRecordStart = (function (original) {
                        return function () {
                            original.apply();
                            updateAnalysers();
                        };
                    })(recorder.onRecordStart);

                    utils.appendActionToCallback(recorder, 'onRecordStart', updateAnalysers, 'analyzer');
                    utils.appendActionToCallback(recorder, 'onRecordComplete', cancelAnalyserUpdates, 'analyzer');
                };

                return {
                    restrict: 'E',
                    require: '^ngAudioRecorder',
                    template: '<div ng-if="!hide" class="audioRecorder-analyzer">' +
                        '<canvas class="analyzer" width="1200" height="400" style="max-width: 100%;"></canvas>' +
                        '</div>',
                    link: link
                };

            }
        ]);

    angular.module('EventListApp')
        .directive('eaAudioRecorder', ['recorderService', '$timeout',
            function (recorderService, $timeout) {
                return {
                    restrict: 'EA',
                    scope: {
                        pid: '@',
                        key: '@',
                        audioModel: '=',
                        id: '@',
                        onRecordStart: '&',
                        onRecordComplete: '&',
                        onPlaybackComplete: '&',
                        onPlaybackStart: '&',
                        onPlaybackPause: '&',
                        onPlaybackResume: '&',
                        onConversionStart: '&',
                        onConversionComplete: '&',
                        showPlayer: '=?',
                        autoStart: '=?',
                        convertMp3: '=?',
                        timeLimit: '=?',

                    },
                    controllerAs: 'recorder',
                    bindToController: true,
                    template: function (element, attrs) {
                        return '<div class="audioRecorder">' +
                            element.html() +
                            '</div>';
                    },
                    controller: 'RecorderCtrl',
                    link: function (scope, element, attrs) {
                        ensureScript("https://static.eventact.com/ea-scripts/ea-files-bs5.js");

                        $timeout(function () {
                            if (recorderService.isAvailable && !recorderService.isHtml5) {
                                //show unsupported message
                            }
                        }, 100);

                    }
                };
            }
        ]);

    angular.module('EventListApp')
        .provider('recorderService',
            function () {
                var handler = null,
                    service = { isHtml5: false, isReady: false },
                    permissionHandlers = { onDenied: null, onClosed: null, onAllow: null },
                    utils

                var html5AudioProps = {
                    audioStream: null,
                    audioContext: null,
                    inputPoint: null,
                    audioInput: null,
                    audioRecorder: null,
                    analyserNode: null,
                    audioChunks: [],
                };

                var html5HandlerConfig = {

                    gotStream: function (stream) {
                        var audioContext = html5AudioProps.audioContext;
                        // Create an AudioNode from the stream.
                        html5AudioProps.audioInput = audioContext.createMediaStreamSource(stream);
                        html5AudioProps.audioInput.connect((html5AudioProps.inputPoint = audioContext.createGain()));
                        html5AudioProps.audioStream = stream;
                        ////analyser
                        //html5AudioProps.analyserNode = audioContext.createAnalyser();
                        //html5AudioProps.analyserNode.fftSize = 2048;
                        //html5AudioProps.inputPoint.connect(html5AudioProps.analyserNode);
                        //html5AudioProps.audioRecorder = new Recorder(html5AudioProps.audioInput);
                        html5AudioProps.audioRecorder = new MediaRecorder(stream);

                        html5AudioProps.audioRecorder.ondataavailable = function (e) {
                            html5AudioProps.audioChunks.push(e.data);
                            postMessage({ 'msg': 'dataReady' });
                        };

                        //create Gain
                        let zeroGain = audioContext.createGain();
                        zeroGain.gain.value = 0.0;
                        html5AudioProps.inputPoint.connect(zeroGain);
                        zeroGain.connect(audioContext.destination);

                        //service booted
                        service.isReady = true;
                        handler = html5AudioProps.audioRecorder;

                        if (angular.isFunction(permissionHandlers.onAllowed)) {
                            if (window.location.protocol == 'https:') {
                                //to store permission for https websites
                                localStorage.setItem("permission", "given");
                            }
                            permissionHandlers.onAllowed();
                        }

                    },
                    failStream: function (data) {
                        if (angular.isDefined(permissionHandlers.onDenied)) {
                            permissionHandlers.onDenied();
                        }
                    },
                    getPermission: function () {
                        navigator.getUserMedia({
                            "audio": true
                        }, html5HandlerConfig.gotStream, html5HandlerConfig.failStream);
                    },
                    init: function () {
                        service.isHtml5 = true;
                        var AudioContext = window.AudioContext || window.webkitAudioContext;
                        if (AudioContext && !html5AudioProps.audioContext) {
                            html5AudioProps.audioContext = new AudioContext();
                        }

                        if (localStorage.getItem("permission") !== null) {
                            //to get permission from browser cache for returning user
                            html5HandlerConfig.getPermission();
                        }
                    }
                };

                navigator.getUserMedia = navigator.getUserMedia
                    || navigator.webkitGetUserMedia
                    || navigator.mozGetUserMedia;


                var init = function () {
                    if (navigator.getUserMedia) {
                        html5HandlerConfig.init();
                    }
                };

                var controllers = {};

                service.controller = function (id) {
                    return controllers[id];
                };

                service.setController = function (id, controller) {
                    controllers[id] = controller;
                };

                service.isAvailable = function () {
                    return service.isHtml5;
                };

                service.getHandler = function () {
                    return handler;
                };

                service.showPermission = function (listeners) {
                    if (!service.isAvailable()) {
                        console.warn("HTML5 not supported.");
                        return;
                    }

                    if (listeners) {
                        angular.extend(permissionHandlers, listeners);
                    }

                    if (service.isHtml5) {
                        html5HandlerConfig.getPermission();
                    }
                };

                service.$html5AudioProps = html5AudioProps;

                service.getBlob = function () {
                    let audioChunks = html5AudioProps.audioChunks;
                    let type = audioChunks.length > 0 ? audioChunks[0].type : 'audio/ogg; codecs=opus';
                    return new Blob(audioChunks, { 'type': type });
                }

                service.clear = function () {
                    html5AudioProps.audioChunks = [];
                    if (handler.state == "recording") {
                        handler.stop();
                        html5AudioProps.audioStream.getAudioTracks()[0].stop();
                    }

                    return this;
                };

                service.clearStream = function () {
                    html5AudioProps.audioStream.getAudioTracks()[0].stop();
                    return this;
                }

                var provider = {
                    $get: ['recorderUtils',
                        function (recorderUtils) {
                            utils = recorderUtils;
                            init();
                            return service;
                        }
                    ],
                };

                return provider;
            })

    angular.module('EventListApp')
        .factory('recorderUtils', [
            /**
             * @ngdoc service
             * @name recorderUtils
             *
             */
            function () {

                // Generates UUID
                var factory = {
                    generateUuid: function () {
                        function _p8(s) {
                            var p = (Math.random().toString(16) + "000000000").substr(2, 8);
                            return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
                        }

                        return _p8() + _p8(true) + _p8(true) + _p8();
                    },
                };

                factory.appendActionToCallback = function (object, callbacks, action, track) {
                    callbacks.split(/\|/).forEach(function (callback) {
                        if (!angular.isObject(object) || !angular.isFunction(action) || !(callback in object) || !angular.isFunction(object[callback])) {
                            throw new Error('One or more parameter supplied is not valid');
                        }
                        ;

                        if (!('$$appendTrackers' in object)) {
                            object.$$appendTrackers = [];
                        }

                        var tracker = callback + '|' + track;
                        if (object.$$appendTrackers.indexOf(tracker) > -1) {
                            console.log('Already appended: ', tracker);
                            return;
                        }

                        object[callback] = (function (original) {
                            return function () {
                                //console.trace('Calling Callback : ', tracker);
                                original.apply(object, arguments);
                                action.apply(object, arguments);
                            };
                        })(object[callback]);

                        object.$$appendTrackers.push(tracker);
                    });
                };

                return factory;
            }
        ]);

    angular.module('EventListApp').factory('recorderAPI', recorderAPI);

    recorderAPI.$inject = ['$http', '$q', 'Constants']
    function recorderAPI($http, $q, Constants) {
        let api = {};
        var sd = {};
        api.setServiceData = function (serviceData) {
            sd = serviceData;
        }

        api.GetDataURL = function (projectID, key) {
            return $http.get(Constants.LocalApiBaseUrl + 'GetRecordingData', { params: { projectID: projectID, key: key } })
        }

        return api;
    }
})();

